export const formatExternalUrl = url => {
    return ( url.search('https://') === 0 ? url : ( url.search('http://') === 0 ? url : ( 'http://' + url ) ) );
};
